<div style="height:calc(100vh - 64px); overflow-y: auto;">
  <div class="container-fluid">
    <br/><br/>
    <div class="row justify-content-center">
      <div class="col-12 col-md-8">
        <div style="display: flex;">
          <mat-icon color="primary" class="rm-header-icon">store</mat-icon>&nbsp;
          <span class="rm-title rm-title-3">KYC</span>
        </div>
        <div>
          <span class="rm-title rm-title-6 rm-lighter">
            {{ util.isAdmin() ? 'These are all of the SUBMITTED KYCs:' : 'These are all of the KYC processes for your Business Unit' }}
          </span>
        </div>
      </div>
      <div class="col-md-3 text-end d-none d-md-block">
        <a *ngIf="!util.isAdmin()" class="link" (click)="goToEntities()">To Initiate a KYC go to Entities Tab</a>
      </div>
    </div>
    <!--    table start-->
    <div class="row justify-content-center d-none d-md-flex" style="padding-top: 25px;">
      <div class="col-12 col-md-11">
        <div class="table-container">
          <div class="row table-inner-container">
            <div class="table-inner-inner-container">
              <table mat-table [dataSource]="dataSource"
                     [multiTemplateDataRows]="true" matSort (matSortChange)="sortData($event)">
                <!-- Search Header -->
                <ng-container matColumnDef="table-name">
                  <th colspan="4" mat-header-cell *matHeaderCellDef>
                    <span style="font-size: large; margin-right: 10px;">KYC</span>&nbsp;
                    <mat-checkbox color="primary" *ngIf="util.isAdmin()"
                      (change)="filterDraftStatus($event)">Show KYCs in Draft Status</mat-checkbox>
                  </th>
                </ng-container>
                <!-- Search Header -->
                <ng-container matColumnDef="search-header">
                  <th colspan="4" mat-header-cell *matHeaderCellDef>
                    <form>
                      <mat-form-field style="width: 100%;">
                        <mat-label>Search</mat-label>
                        <input type="text" matInput (keyup)="applyFilter($event)" #input/>
                        <mat-icon matSuffix>search</mat-icon>
                      </mat-form-field>
                    </form>
                  </th>
                </ng-container>
                <!-- Column -->
                <ng-container matColumnDef="business">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="business"> Business Unit</th>
                  <td mat-cell
                      *matCellDef="let element" style="padding: 5px;">
                    <app-user-card [firstName]="element.businessUnitMiniModel?.displayName"
                                   [displayName]="element.businessUnitMiniModel?.profile"
                                   [borderColor]="'transparent'"
                                   [sideColor]="'#ff0000'"
                                   [image]="element.businessUnitMiniModel?.['imageUrl']"
                                   (click)="util.isAdmin()? util.viewBusinessUnit(element.businessUnitMiniModel?.id, 'entities') : null"
                                   [ngStyle]="{'cursor': util.isAdmin()? 'pointer':''}"
                                   [highlightOnHover]="util.isAdmin()"
                    ></app-user-card>
                  </td>
                </ng-container>
                <!-- Column -->
                <ng-container matColumnDef="entityName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="entityName"> Entity Name</th>
                  <td mat-cell *matCellDef="let element">
                    <span>{{ element.businessUnitEntityName }}</span>
                  </td>
                </ng-container>
                <!-- Column -->
                <ng-container matColumnDef="entityType">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="entityType">Entity Type</th>
                  <td mat-cell *matCellDef="let element">
                    <span>{{ getEntityTypeString(element) }}</span>
                  </td>
                </ng-container>
                <!-- Column -->
                <ng-container matColumnDef="kycName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="kycName"> KYC Name</th>
                  <td mat-cell *matCellDef="let element">
                    <span>{{ element.kycName }}</span>
                  </td>
                </ng-container>
                <!-- Column -->
                <ng-container matColumnDef="kycStatus">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="kycStatus"> KYC Status</th>
                  <td mat-cell *matCellDef="let element">
                    <span [appStatus]="element.kycRondeivuStatus">{{ getStatusString(element.kycRondeivuStatus) }}</span>
                  </td>
                </ng-container>
                <!-- Column -->
                <ng-container matColumnDef="kycCreated">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="kycCreated">Created On</th>
                  <td mat-cell *matCellDef="let element">
                    <div class="date-stacked">
                      <span>{{ element.createdOn | date : 'mediumDate' }}</span>
                      <span>{{ element.createdOn | date : 'shortTime' }}</span>
                    </div>
                  </td>
                </ng-container>
                <!-- Column -->
                <ng-container matColumnDef="kycModified">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="kycModified">Last Modified On</th>
                  <td mat-cell *matCellDef="let element">
                    <div class="date-stacked">
                      <span>{{ element.lastModified | date : 'mediumDate' }}</span>
                      <span>{{ element.lastModified | date : 'shortTime' }}</span>
                    </div>
                  </td>
                </ng-container>
                <!-- Column -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef> View</th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-icon-button type="button" 
                      (click)="viewEntityKyc(element)"
                      [hasPermission]="util.Permission.CAN_ACCESS_KYC"
                      title="View KYC">
                      <mat-icon>east</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <!--table rows-->
                <tr mat-header-row *matHeaderRowDef="['table-name','search-header'];"></tr>
                <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky:true;"></tr>
                <tr mat-row *matRowDef="let element; columns: columnsToDisplay;">
                  <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">No data matching the filter.</td>
                </tr>
              </table>
            </div>
          </div>
          <mat-paginator style="background-color: white; z-index: 99;" [pageSizeOptions]="[25, 50, 100]"
                         [pageSize]="100"
                         aria-label="Select page of users"></mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
